<div class="modal-body" id="modal-body">
  <ng-container *ngIf="contentType === 'detail'; else listBlock">
    <app-meraki-organizations-detail [pk]="pk" [mode]="mode" [defaults]="defaults"
                                   (detailSaved)="modal.close($event)"
                                   (detailCancelled)="modal.dismiss()">
    </app-meraki-organizations-detail>
  </ng-container>
  <ng-template #listBlock>
    <app-meraki-organizations-list (rowClick)="modal.close($event)" [disableUrlUpdate]="true"
                                  [disabledButtons]="disabledButtons" [disabledColumns]="disabledColumns"
                                  [filters]="filters">
    </app-meraki-organizations-list>
  </ng-template>
</div>